import { Component } from '@angular/core';
import { AccountRepository } from '@timechef/features/account/state';

@Component({
  selector: 'app-cgu',
  templateUrl: './cgu.component.html',
  styleUrls: ['./cgu.component.scss'],
  standalone: false,
})
export class CguComponent {
  language$ = this.accountRepo.language$;

  constructor(private accountRepo: AccountRepository) {}
}
